<ng-container [ngSwitch]="type">
  <h1 *ngSwitchCase="'h1'" [ngStyle]="styles" [ngClass]="colorClass">
    {{ text }}
  </h1>

  <h2 *ngSwitchCase="'h2'" [ngStyle]="styles" [ngClass]="colorClass">
    {{ text }}
  </h2>

  <h3 *ngSwitchCase="'h3'" [ngStyle]="styles" [ngClass]="colorClass">
    {{ text }}
  </h3>

  <h4 *ngSwitchCase="'h4'" [ngStyle]="styles" [ngClass]="colorClass">
    {{ text }}
  </h4>

  <h5 *ngSwitchCase="'h5'" [ngStyle]="styles" [ngClass]="colorClass">
    {{ text }}
  </h5>

  <h6 *ngSwitchCase="'h6'" [ngStyle]="styles" [ngClass]="colorClass">
    {{ text }}
  </h6>

  <p *ngSwitchCase="'p'" [ngStyle]="styles" [ngClass]="colorClass">
    {{ text }}
  </p>

  <span *ngSwitchCase="'span'" [ngStyle]="styles" [ngClass]="colorClass">{{
    text
  }}</span>

  <div *ngSwitchCase="'div'" [ngStyle]="styles" [ngClass]="colorClass">
    {{ text }}
  </div>

  <span *ngSwitchCase="'label'" [ngStyle]="styles" [ngClass]="colorClass">{{
    text
  }}</span>

  <a
    *ngSwitchCase="'link'"
    [ngStyle]="styles"
    [ngClass]="colorClass"
    [href]="pathLink"
    [target]="target"
    >{{ text }}</a
  >

  <a
    *ngSwitchCase="'rLink'"
    [ngStyle]="styles"
    [ngClass]="colorClass"
    [routerLink]="pathLink"
    >{{ text }}</a
  >
</ng-container>
